import { api, Api } from '@/services/api';
import type {
  TournamentMatches,
  TournamentMatchesParams,
  TournamentMatchesResult,
  TournamentMatchesResultImageParams,
  TournamentMatchesResultParams,
  TournamentMatchesResults,
} from '@/types';

const matchesEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    tournamentMatches: builder.query<{ data: TournamentMatches[] }, TournamentMatchesParams>({
      query: (params) => ({
        url: Api.TournamentMatches.replace(':id', (params.id ?? 0).toString()),
        params,
      }),
      providesTags: ['Matches'],
    }),
    tournamentMatchDetail: builder.query<TournamentMatches, { id: number; matchId: number }>({
      query: (params) => ({
        url: Api.TournamentMatcheDetail.replace(':id', params.id.toString()).replace(
          ':matchId',
          params.matchId.toString(),
        ),
      }),
      providesTags: (_r, _e, { matchId }) => [{ type: 'Matches', id: matchId }],
    }),
    tournamentMatchesResult: builder.mutation<TournamentMatchesResult, TournamentMatchesResultParams>({
      query: (params) => ({
        url: Api.TournamentMatchesResult.replace(':id', params.id.toString()).replace(
          ':matchId',
          params.matchId.toString(),
        ),
        method: 'POST',
        body: { state: params.body },
      }),
      invalidatesTags: ['Tournaments', 'Matches'],
    }),
    tournamentMatchesResultImage: builder.mutation<
      TournamentMatchesResult,
      TournamentMatchesResultImageParams
    >({
      query: (params) => ({
        url: Api.TournamentMatchesResult.replace(':id', params.id.toString()).replace(
          ':matchId',
          params.matchId.toString(),
        ),
        method: 'POST',
        body: params.body,
      }),
      invalidatesTags: ['Tournaments', 'Matches'],
    }),
    tournamentMatchesResults: builder.query<
      TournamentMatchesResults,
      { id: number; matchId: number }
    >({
      query: (params) => ({
        url: Api.TournamentMatchesResult.replace(':id', params.id.toString()).replace(
          ':matchId',
          params.matchId.toString(),
        ),
      }),
      providesTags: ['Matches'],
    }),
    matchCheckin: builder.mutation<void, { tournamentId: number; matchId: number }>({
      query: (params) => ({
        url: Api.MatchCheckin.replace(':id', params.tournamentId.toString()).replace(
          ':matchId',
          params.matchId.toString(),
        ),
        method: 'POST',
        body: {},
      }),
      invalidatesTags: ['Matches'],
    }),
    matchForfeit: builder.mutation<void, { tournamentId: number; matchId: number }>({
      query: (params) => ({
        url: Api.MatchForfeit.replace(':id', params.tournamentId.toString()).replace(
          ':matchId',
          params.matchId.toString(),
        ),
        method: 'POST',
        body: {},
      }),
      invalidatesTags: ['Matches'],
    }),
  }),
});

export const {
  useTournamentMatchesQuery,
  useTournamentMatchDetailQuery,
  useTournamentMatchesResultMutation,
  useTournamentMatchesResultImageMutation,
  useTournamentMatchesResultsQuery,
  useMatchCheckinMutation,
  useMatchForfeitMutation,
} = matchesEndpoints;
